import { useState, useEffect } from 'react';
import { FaArrowDown, FaArrowUp } from 'react-icons/fa';

const ScrollToBottom = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isBottom, setIsBottom] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);

  // 스크롤 위치에 따라 버튼 표시 여부 결정
  useEffect(() => {
    const toggleVisibility = () => {
      const scrollHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY;
      const clientHeight = document.documentElement.clientHeight;

      // 페이지 전체 높이의 5% 이상 스크롤됐을 때 버튼 표시
      if (scrollTop > scrollHeight * 0.05) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }

      // 페이지 하단에 도달했는지 확인 (50px 여유)
      if (scrollHeight - scrollTop - clientHeight < 50) {
        setIsBottom(true);
      } else {
        setIsBottom(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  // 페이지 맨 아래로 스크롤
  const scrollToBottom = () => {
    setIsTransitioning(true);
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth',
    });
    // 스크롤 완료 후 버튼 다시 표시
    setTimeout(() => {
      setIsTransitioning(false);
    }, 1000); // 스크롤 애니메이션 시간과 맞춤
  };

  // 페이지 맨 위로 스크롤
  const scrollToTop = () => {
    setIsTransitioning(true);
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    // 스크롤 완료 후 버튼 다시 표시
    setTimeout(() => {
      setIsTransitioning(false);
    }, 1000); // 스크롤 애니메이션 시간과 맞춤
  };

  return (
    <>
      {isVisible && !isTransitioning && (
        <button
          onClick={isBottom ? scrollToTop : scrollToBottom}
          className="fixed bottom-8 right-8 bg-[#343C49] text-white p-3 rounded-full shadow-lg hover:bg-[#4A5568] transition-all duration-300 z-50"
          aria-label={
            isBottom ? '페이지 맨 위로 이동' : '페이지 맨 아래로 이동'
          }
        >
          {isBottom ? (
            <FaArrowUp className="w-6 h-6" />
          ) : (
            <FaArrowDown className="w-6 h-6" />
          )}
        </button>
      )}
    </>
  );
};

export default ScrollToBottom;
